import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * Route guard that requires active authentication and forbids guest mode.
 * Users who are not logged in or in guest mode (is_guest === true)
 * are redirected to /auth with the original target saved for post-login return.
 */
export default function ProtectedRoute({ children }) {
  const { isAuthenticated, user, isGuest } = useAuth();
  const location = useLocation();

  const isAuthorized = Boolean(isAuthenticated && user && !user.is_guest && !isGuest);

  if (!isAuthorized) {
    const returnUrl = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/auth?redirect=${returnUrl}`} state={{ from: location }} replace />;
  }

  return children;
}
